import styled from 'styled-components';

export const Main = styled.div`
  min-height: 80vh;
  display: flex;
  // align-items: center;
  // justify-content: center;
  // flex-direction: column;
  @media (max-width: 900px) {
    flex-direction: column;
  }
  font-family: 'Roboto', sans-serif;
  width: 100%;
  p {
    width: 50%;
  }
  hr {
    height: 100%;
    width: 1px;
    z-index: 1;
  }
  // font-size: 150%;
  // background-image: url(${({ theme }) => theme.contactBg});
  background-color: ${({ theme }) => theme.font3};

  color: ${({ theme }) => theme.font4};
  p img {
    width: 50px;
  }
  button {
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    border: none;
    border-radius: 3px;
    width: 180px;
    height: 40px;
    transition: 0.3s;
    background-color: ${({ theme }) => theme.font3};
    color: ${({ theme }) => theme.background2};
    cursor: pointer; /* Cursor de ponteiro ao passar o mouse */

    &:hover {
      background-color: ${({ theme }) =>
        theme.font2}; /* Efeito ao passar o mouse */
    }

    @media (max-width: 1000px) {
      width: 280px;
    }
  }
  @media (max-width: 1400px) {
    // min-height: 120vh;

    padding-top: 100px;
    padding-bottom: 200px;

    // margin-bottom: 200px;
  }
  // height: 80vh;
  background-color: ${({ theme }) => theme.headerBottom};
`;

export const Links = styled.div`
  @media (max-width: 1400px) {
    flex-direction: column
  }
  display: flex;
  flex-direction: flex;
  gap: 2rem;
  a {
    img {
      width: 30px;
      filter: ${({ theme }) =>
        theme.theme === 'dark' ? `invert(0)` : `invert(90%)`};
    }
  }
}

`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5rem;
  height: 70vh;
  @media (max-width: 500px) {
    flex-direction: column;
    height: 100%;
  }
  @media (max-width: 1200px) {
    gap: 2rem;

    flex-direction: column;
    height: 100%;
  }
`;

export const Div = styled.div`
  // div {
  //   display: flex;
  //   // align-items: center;
  //   flex-direction: column;
  //   justify-content: center;
  //   width: 700px;
  //   img {
  //     width: 20px;
  //   }
  //   @media (max-width: 500px) {
  //     width: 200px;
  //   }
  //   @media (max-width: 1000px) {
  //     width: 400px;
  //   }
  //   @media (max-width: 800px) {
  //     width: 300px;
  //   }
  //   text-align: center;
  //   gap: 1rem;
  //   text-align: justify;
  //   .elem {
  //     width: 100%;
  //   }
  // }
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  // width: 30rem;
  img {
    width: 20px;
  }
  @media (max-width: 500px) {
    width: 200px;
  }
  @media (max-width: 1000px) {
    width: 400px;
  }
  @media (max-width: 800px) {
    width: 300px;
  }
  text-align: center;
  gap: 1rem;
  text-align: justify;
  .elem {
    width: 50%;
    position: absolute;
    z-index: 0;
    // height: 50vh; /* Ocupa metade da altura da tela */
    // object-fit: cover; /* Ajusta a imagem para cobrir a área definida */
    // margin-top: 20px; /* Adiciona espaço antes da imagem */
    bottom: 110px;
    left: 0px;
  }
`;

// export const Form = styled.form`
//   display: flex;
//   align-items: center;
//   flex-direction: column;
//   justify-content: center;
//   gap: 1rem;
//   input,
//   textarea,
//   button {
//     font-family: 'Roboto', sans-serif;
//     font-size: 14px;
//     border: none;
//     border: 1px solid white;
//     border-radius: 3px;
//     width: 120px;
//     height: 40px;
//     transition: 0.3s;
//     background-color: ${({ theme }) => theme.font3};
//     color: ${({ theme }) => theme.background2};
//     cursor: pointer; /* Cursor de ponteiro ao passar o mouse */

//     &:hover {
//       background-color: ${({ theme }) =>
//         theme.font2}; /* Efeito ao passar o mouse */
//     }

//     @media (max-width: 1000px) {
//       width: 280px;
//     }
//   }
// `;
export const Form = styled.form`
  display: flex;
  flex-direction: column;
  background-color: transparent;
  justify-content: center;
  // padding-top: 30vh;
  gap: 1.5rem;
  // align-items: center;
  color: ${({ theme }) => theme.font4};
  width: 30rem;
  @media (max-width: 1400px) {
    width: auto;
  }
  button {
    float: right;
  }
  textarea {
    width: 100%;
    height: 150px;
    font-family: 'Roboto', sans-serif;
    background-color: ${({ theme }) => theme.headerBottom};
    border: 1px solid white;
  }
  textarea::placeholder {
    color: ${({ theme }) => theme.font4};
    opacity: 1; /* Assegura que a cor será visível, o valor padrão do opacity é 0.5 */
  }
  input::placeholder {
    color: ${({ theme }) => theme.font4};
    opacity: 1; /* Assegura que a cor será visível, o valor padrão do opacity é 0.5 */
  }
  input {
    width: 500px;
    @media (max-width: 1400px) {
      width: auto;
    }
    border: none;
    cursor: pointer;
    placeholder {
      color: ${({ theme }) => theme.font4};
    }
    background-color: transparent; /* Fundo transparente */
    border-bottom: 1px solid ${({ theme }) => theme.font4}; /* Adiciona uma linha abaixo do input */
    padding: 5px 0; /* Para dar algum espaço interno */
  }
`;
